<div class="white-box p-3 mb-3">
	<button #hiddenPrintBtn style="display: none" ngxPrint [useExistingCss]="true" printSectionId="to-print-content" printTitle="{{ 'truck_site_summary_report.title' | translate }}"></button>
	<div class="print">
		<button class="btn fa fa-print fa-lg print-btn" (click)="openPrintModal()" *ngIf="totalTrucksPdf"  title="{{'g.print' | translate}}"></button>
	</div>
	<div class="filter-container">
		<!-- period filter -->
		<div class="col-sm-6 col-md-3 col-lg-3">
			<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
			<ng-select
				class="select"
				[items]="periods"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'period', value: $event.value})"
				[placeholder]="'g.durations' | translate"
				[(ngModel)]="selectedPeriod"
			></ng-select>
		</div>
		<!-- truck type filter -->
		<div class="col-sm-6 col-md-3 col-lg-3">
			<label for="truckTypeSelect">{{"exception_reports.truck_types" | translate}}</label>
			<ng-select
				class="select"
				[items]="truckTypes"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'truckType', value: $event.value})"
				[placeholder]="'g.type' | translate"
				[(ngModel)]="selectedTruckType"
			></ng-select>
		</div>
		<!-- days filter -->
		<div class="col-sm-6 col-md-3 col-lg-3">
			<label for="workingDaysSelect">{{"operation_analysis.working_days" | translate}}</label>
			<ng-select
				class="select"
				[items]="daysFilters"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'daysFilter', value: $event.value})"
				[placeholder]="'g.durations' | translate"
				[(ngModel)]="selectedDaysFilter"
			></ng-select>
		</div>

		<!-- Manufacturer filter -->
		<div class="col-sm-6 col-md-3 col-lg-3">
			<label for="workingDaysSelect">{{"devices.truck_manufacturer" | translate}}</label>
			<ng-select
				class="select"
				[items]="truckManufacturer"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'truckManufacturer', value: $event.value})"
				[placeholder]="'g.durations' | translate"
				[(ngModel)]="selectedtruckManufacturer"
			></ng-select>
		</div>

		<!-- Vintage filter -->
		<div class="col-sm-6 col-md-3 col-lg-3"> 
			<label for="batteryVintageSelect">{{"devices.truck_vintage" | translate}}</label>
			<ng-select
				name="batteryVintageSelect"
				id="batteryVintageSelect"
				class="select"
				[multiple]="true"
				[items]="vintageOptionsDropdown"
				[addTag]="true"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.truck_vintage' | translate"
				[(ngModel)]="selectedBatteryVintageForScores"
				(ngModelChange)="batteryVintageSelectionChanged()"
			>
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<span>
						<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
						<span class="ng-value-label">{{item.label}}</span>
					</span>
				</ng-template>
			</ng-select>
		</div> 
	</div>
	<div class="btn-content m-4">
		<h1 class="h3">{{'utilization.site_performance_scores' | translate}}</h1>
		<!-- <button class="btn fa fa-print fa-lg print-btn" (click)="openPrintModal()" *ngIf="totalTrucksPdf"  title="{{'g.print' | translate}}"></button> -->
	</div>

	<app-modal #printModal title="{{ 'g.print_truck_site_summary_report' | translate }}" [hasCloseButton]="false" [hasConfirmButton]="false">
		<div class="p-3">
					<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
					<ng-select
						class="select"
						[items]="periods"
						[addTag]="false"
						[clearable]="false"
						[searchable]="false"
						bindLabel="label"
						bindValue="value"
						(change)="onSelectionReportChanged({filter: 'period', value: $event.value})"
						[placeholder]="'g.durations' | translate"
						[(ngModel)]="selectedReportPeriod"
					></ng-select>
					<label class="mt-3" for="workingDaysSelect">{{"operation_analysis.working_days" | translate}}</label>
					<ng-select
						class="select"
						[items]="daysFilters"
						[addTag]="false"
						[clearable]="false"
						[searchable]="false"
						bindLabel="label"
						bindValue="value"
						(change)="onSelectionReportChanged({filter: 'daysFilter', value: $event.value})"
						[placeholder]="'g.durations' | translate"
						[(ngModel)]="selectedReportDaysFilter"
					></ng-select>
			<div class="mt-3 text-end">
				<button class="btn btn-primary" (click)="confirmPrint()">Print</button>
			</div>
		</div>
	</app-modal>

	<app-truck-site-summary-report class="print-content"  id="to-print-content" [totalTrucks]="totalTrucksPdf" [data]="trucksReportData" [siteInfo]="siteInfo" [selectedPeriodFormatted]="selectedPeriodFormatted" [period]="selectedReportPeriod" [selectedDays]="selectedReportDaysFilter"></app-truck-site-summary-report>

	<app-truck-summary-report-performance
		*ngIf="data"
		[truckManufacturer]="selectedtruckManufacturer"
		[selectedTruckType]="selectedTruckType"
		[selectedBatteryVintage]="selectedBatteryVintageForScores"
		[data]="data"
		[period]="selectedPeriod"
		[showTooltip]="true"
		[selectedDays]="selectedDaysFilter"
		[totalTrucks]="totalTrucks"
		[devices]="devices"
		[tooltipType]="'site'"
	></app-truck-summary-report-performance>	
	<!-- <app-site-fleet-utilization-score
		*ngIf="data"
		[data]="data"
		[devices]="devices"
		[selectedDaysFilter]="selectedDaysFilter"
		[selectedPeriod]="selectedPeriod"
		[selectedTruckType]="selectedTruckType"
		[totalTrucks]="totalTrucks"
	></app-site-fleet-utilization-score>
	<app-site-energy-usage-score 
		*ngIf="data"
		[data]="data"
		[devices]="devices"
		[selectedDaysFilter]="selectedDaysFilter"
		[selectedPeriod]="selectedPeriod"
		[selectedTruckType]="selectedTruckType"
	></app-site-energy-usage-score> -->
	<app-truck-utilization-score 
		*ngIf="data"
		[data]="data"
		[devices]="devices"
		[selectedDaysFilter]="selectedDaysFilter"
		[selectedPeriod]="selectedPeriod"
		[selectedTruckType]="selectedTruckType"
		[selectedBatteryVintage]="selectedBatteryVintageForScores"
		[truckManufacturer]="selectedtruckManufacturer"
	></app-truck-utilization-score>
</div>

<div class="white-box p-3 mb-3">
	<div class="row col-xl-12 mb-4 mt-5" *ngIf="truckTypesDailyFleet.length || truckManufacturerDailyFleet.length">
		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="siteInstallationDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-4 col-md-4">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate" [maxDate]="maxDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>

	<div class="row col-xl-12 mb-4" *ngIf="truckTypesDailyFleet.length || truckManufacturerDailyFleet.length">
		<!-- truck type filter -->
		<div class="col-xl-4 col-md-4">
			<label for="workingDaysSelect">{{"devices.truck_type" | translate}}</label>
			<ng-select
				class="select"
				[items]="truckTypesDailyFleet"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'g.type' | translate"
				[(ngModel)]="selectedTruckTypeDailyFleet"
				(change)="onSelectionChanged({filter: 'truckTypeForDailyFleet', value: $event.value})"
			></ng-select>
		</div>

		<!-- truck Manufacturer filter -->
		<div class="col-xl-4 col-md-4">
			<label for="workingDaysSelect">{{"devices.truck_manufacturer" | translate}}</label>
			<ng-select
				class="select"
				[items]="truckManufacturerDailyFleet"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'truckManufacturerForDailyFleet', value: $event.value})"
				[placeholder]="'g.type' | translate"
				[(ngModel)]="selectedTruckManufacturerDailyFleet"
			></ng-select>
		</div>
	</div>

	<h1 class="h3 m-3 mt-5">{{'utilization.daily_truck_fleet_activity_metrics' | translate}}</h1>
	<app-daily-truck-fleet-activity-metrics
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedTruckType]="selectedTruckTypeDailyFleet"
		[selectedTruckManufacturer]="selectedTruckManufacturerDailyFleet"
		(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
	></app-daily-truck-fleet-activity-metrics>

	<app-daily-fleet-utilization
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedTruckType]="selectedTruckTypeDailyFleet"
		[selectedTruckManufacturer]="selectedTruckManufacturerDailyFleet"
		(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
	></app-daily-fleet-utilization>

	<app-daily-ah-fleet-utilization
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedTruckType]="selectedTruckTypeDailyFleet"
		[selectedTruckManufacturer]="selectedTruckManufacturerDailyFleet"
		(prepareParentFiltersOptions)="prepareParentFiltersOptions($event)"
	></app-daily-ah-fleet-utilization>
</div>
<div class="white-box p-3 mb-3">
	<!-- <app-hourly-fleet-utilization *ngIf="data.hourly_fleet_utilization" [data]="data.hourly_fleet_utilization" [devices]="devices"></app-hourly-fleet-utilization> -->
	<app-relative-truck-utilization *ngIf="data" [devices]="devices" [data]="data"></app-relative-truck-utilization>
	<app-site-performance *ngIf="0"></app-site-performance>
</div>